import React from 'react';
import { Relationship } from "../../enums/Relationship";
import ClaimType from "../common/ClaimType";
import { defaultPregnancyDisabilityPhysicianFormValues } from "../../disability/PregnancyDisabilityPhysicianFormValues";
import _ from "lodash";
import {
    defaultPhysicalIllnessOrInjuryDisabilityPhysicianFormValues
} from "../../disability/PhysicalIllnessOrInjuryDisabilityPhysicianFormValues";
import { defaultMentalHealthDisabilityPhysicianFormValues } from "../../disability/MentalHealthDisabilityPhysicianFormValues";
import { useFormikContext } from "formik";
import { DisabilityPhysicianFormValues } from "../../disability/DisabilityPhysicianFormValues";
import { ConditionType } from "../../enums/ConditionType";
import { SicknessType } from "../../enums/SicknessType";
import SelectDropdown from "../../input/SelectDropdown";

const PhysicianClaimType = () => {
    const { values, setFieldValue, resetForm } = useFormikContext<DisabilityPhysicianFormValues>();

    const conditionType = values.conditionType;
    const sicknessType = values.sicknessType;
    React.useEffect(() => {
        if(conditionType === ConditionType.PREGNANCY) {
            resetFormFor(defaultPregnancyDisabilityPhysicianFormValues);
        } else if(ConditionType.INJURY === conditionType || SicknessType.PHYSICAL_ILLNESS === sicknessType) {
            resetFormFor(defaultPhysicalIllnessOrInjuryDisabilityPhysicianFormValues);
        } else if(sicknessType === SicknessType.MENTAL_HEALTH) {
            resetFormFor(defaultMentalHealthDisabilityPhysicianFormValues);
        }
        // eslint-disable-next-line
    }, [conditionType, sicknessType, resetForm])

    const patientIsEmployee = values.relationship === Relationship.EMPLOYEE;
    const patientFirstName = values.patientFirstName;
    const patientLastName = values.patientLastName;
    React.useEffect(() => {
        if(patientIsEmployee && patientFirstName) {
            setFieldValue('firstName', patientFirstName);
            setFieldValue('lastName', patientLastName);
            setFieldValue('patientRelationship', 'The patient themselves');
            setFieldValue('patientRequiresCare', 'Yes');
        }
    }, [setFieldValue, patientIsEmployee, patientFirstName, patientLastName])

    return (
        <ClaimType
                   headerText="What type of claim is being requested?"
                   onlyShowMedicalRelatedLeaveTypes={true}
                   skipLeaveTypeServiceCall={true}
                   children={<>
                       {ConditionType.SICKNESS === conditionType
                           && <SelectDropdown id="sickness-type"
                                        label="Sickness type"
                                        required={true}
                                        options={Object.keys(SicknessType).map(s => ({
                                            id: s.replace(/_/g, '-').toLowerCase(),
                                            text: (SicknessType as any)[s]
                                        }))}/>}
                   </>}
        />
    )

    function resetFormFor(defaultValues: any) {
        resetForm?.({
            values: leftJoin(defaultValues, values)
        })
    }

    function leftJoin(a: any, b: any) {
        return {
            ...a,
            ..._.pick(b, Object.keys(b).filter(k => Object.keys(a).includes(k)))
        };
    }
};
export default PhysicianClaimType;